import React from 'react';
import { Box, useMediaQuery, useTheme } from '@mui/material';
import LogoBlackSrc from '../../../../../assets/connect_by_flexeserve_logo_BLK_Color.svg';
import LogoWhiteSrc from '../../../../../assets/connect_by_flexeserve_logo_WHT_Color.svg';

function HeaderLogo() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const logoSrc = theme.palette.mode === 'dark' ? LogoWhiteSrc : LogoBlackSrc;

  return (
    <Box
      component={'img'}
      src={logoSrc}
      alt="flexeserve logo"
      sx={(theme) => ({
        fontSize: isMobile ? '0.6rem' : undefined,
        height: '2.5rem',
        color: theme.palette.text.primary,
      })}
    />
  );
}

export default HeaderLogo;
